import styled, { css, keyframes } from 'styled-components'

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`

const getColour = (props) => {
  const { kind, theme } = props
  switch (kind) {
    default:
    case 'default': {
      return theme.color_primary
    }
    case 'white': {
      return theme.color_white
    }
    case 'green': {
      return theme.color_secondary_dark
    }
  }
}

const Spinner = styled.div`
  position: absolute;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};

  ${(props) => css`
    ${props.centered &&
      css`
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      `}
  `}
`

const SVG = styled.svg`
  && {
    animation: ${rotate} 2s linear infinite;
    transform-origin: center center;
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    position: relative;
  }
`

const Circle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: ${dash} 1.5s ease-in-out infinite;
  stroke-linecap: round;
  stroke: ${(props) => getColour(props)};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* larger dash array in IE as dashoffset is not supported */
    stroke-dasharray: 15, 200;
  }
`

export { Circle, Spinner, SVG, getColour }
